import { TeamsAPI } from 'api/teams';
import { teamsCollection } from './teams-collection';
export const deleteTeamsByRole = async (roleId)=>{
    await TeamsAPI.deleteTeamsByRole(roleId);
    const all = teamsCollection.getAll();
    all.forEach((team)=>{
        if (team.roleId === roleId) {
            teamsCollection.externalDelete(team.teamId);
        }
    });
};
export const pushTeam = (team)=>{
    teamsCollection.push([
        team
    ], {
        source: 'fetch'
    });
};
export const pushTeams = (teams)=>{
    teamsCollection.push(teams, {
        source: 'fetch'
    });
};
export const removeTeamFromCollection = (teamId)=>{
    teamsCollection.externalDelete(teamId);
};
